// extracted by mini-css-extract-plugin
export default {"grid":"TaskBody_grid__UU8p4","main":"TaskBody_main__rDBwo","aside":"TaskBody_aside__TKDDq","item":"TaskBody_item__bJ-az"};